import { render, staticRenderFns } from "./PaperUploadList.vue?vue&type=template&id=448c8e6a&scoped=true&"
import script from "./PaperUploadList.vue?vue&type=script&lang=js&"
export * from "./PaperUploadList.vue?vue&type=script&lang=js&"
import style0 from "./PaperUploadList.vue?vue&type=style&index=0&id=448c8e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448c8e6a",
  null
  
)

export default component.exports